<template>
  <div class="health-check" :class="`health-check--${mode}`">
    <div class="health-check__close" data-aos="fade" data-aos-delay="100">
      <ButtonTimer
          :data="buttonTimerData"
          @onClick="closeModal"
          @onComplete="closeModal"/>
    </div>

    <div class="health-check__content content-container">
      <div class="health-check__base">
        <div class="health-check__top">
          <p class="health-check__title h5" v-if="title" data-aos="fade" data-aos-delay="125">
            {{ title }}
          </p>
          <p class="health-check__text h3" v-if="text" data-aos="fade" data-aos-delay="150">
            {{ text }}
          </p>
        </div>

        <div class="health-check__items" v-if="items">
          <div class="health-check__item"
               v-for="(item, index) in items"
               data-aos="fade" data-aos-delay="100"
               :key="index">
            <button type="button"
                    class="health-check__button"
                    :class="{'health-check__button--active': item.active}"
                    @click="selectMood(item.id, index)">
              <span class="health-check__icon">
                <Image :data="item.image"/>
              </span>
              <span class="health-check__text h6">
                {{ item.text }}
              </span>
            </button>
          </div>
        </div>

        <p class="health-check__message" :class="messageClass" v-if="message">
          <span v-html="message" data-aos="fade" data-aos-delay="125"></span>
        </p>
      </div>

      <div class="health-check__actions" data-aos="fade" data-aos-delay="100">
        <div class="health-check__action" v-if="mode === 'first-check'">
          <AppButton :data="startAction" @onClick="start"/>
        </div>
        <div class="health-check__action" v-if="mode === 'second-check'">
          <AppButton :data="doneAction" @onClick="done"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import AppButton from '@/components/AppButton/AppButton.vue';
import Image from '@/components/Image/Image.vue';
import ButtonTimer from '@/components/ButtonTimer/ButtonTimer.vue';

export default {
  name: 'HealthCheck',
  components: { ButtonTimer, Image, AppButton },
  data() {
    return {
      // выбранный id настроения
      selectedStatusId: null,
      stage: 'start',

      items: null,
      activeIndex: null,
      buttonTimerData: {
        icon: '24/cross',
        animate: true,
        time: 15,
      },
    };
  },
  computed: {
    ...mapGetters({
      currentProgramId: 'app/getCurrentProgramId',
      data: 'app/getStatusesData',
      mode: 'app/getMode',
      userId: 'app/getUserId',
    }),

    message() {
      if (!this.activeItem) return '';

      const { previewText = '', detailText = '' } = this.activeItem;

      if (this.mode === 'first-check') {
        return previewText;
      }

      return detailText;
    },

    messageClass() {
      if (this.activeIndex === null) return '';

      return `health-check__message--${this.activeIndex + 1}`;
    },

    // выбран ли один из статусов
    activeItem() {
      if (!this.items) return null;

      return this.items.find((item) => item.active);
    },
    title() {
      return this.data.title;
    },
    text() {
      return this.data.text;
    },
    startAction() {
      return {
        name: 'start',
        title: this.$store.getters['app/getStaticValue']('STATUS_LIST_BUTTON_START_TITLE'),
        text: this.$store.getters['app/getStaticValue']('STATUS_LIST_BUTTON_START_TITLE'),
      };
    },
    doneAction() {
      return {
        name: 'done',
        title: this.$store.getters['app/getStaticValue']('STATUS_LIST_BUTTON_DONE_TITLE'),
        text: this.$store.getters['app/getStaticValue']('STATUS_LIST_BUTTON_DONE_TITLE'),
      };
    },
  },
  mounted() {
    const items = this.data?.items || [];

    this.items = items.map((item) => ({
      ...item,
      active: false,
    }));

    if (this.mode === 'second-check' && this.currentProgramId) {
      // будем считать, что медитация прослушана,
      // тк открыт экран с выбором настроения (second-check)
      this.setProgress();
    }

    this.stage = this.mode === 'first-check' ? 'start' : 'end';
  },
  methods: {
    ...mapMutations({
      setAppMode: 'app/setMode',
      setDoneMeditation: 'app/setDoneMeditation',
    }),

    closeModal() {
      if (this.mode === 'first-check') {
        this.setAppMode('player');
      } else {
        this.setAppMode('body');
      }
    },
    selectMood(id, index) {
      this.items.forEach((item, idx) => {
        this.items[idx].active = index === idx;
      });

      this.activeIndex = index;
      this.selectedStatusId = id;
    },
    start() {
      this.setAppMode('player');

      this.sendData();
    },
    done() {
      this.setAppMode('body');

      this.sendData();
    },
    skip() {
      if (this.mode === 'first-check') {
        this.setAppMode('player');
      } else {
        this.setAppMode('body');
      }
    },

    setProgress() {
      if (!localStorage.getItem('NLMK_PROGRESS')) {
        const arr = [this.currentProgramId];
        localStorage.setItem('NLMK_PROGRESS', JSON.stringify(arr));

        // заносим изменения в store
        this.setDoneMeditation(arr);
      } else {
        const progressArray = JSON.parse(localStorage.getItem('NLMK_PROGRESS'));
        progressArray.push(this.currentProgramId);
        const set = new Set(progressArray);
        const uniqueArray = [...set];
        localStorage.setItem('NLMK_PROGRESS', JSON.stringify(uniqueArray));

        // заносим изменения в store
        this.setDoneMeditation(progressArray);
      }
    },

    async sendData() {
      try {
        const formData = new FormData();

        if (this.selectedStatusId) {
          formData.append('status', this.selectedStatusId);

          formData.append('session', this.userId);
          formData.append('meditation', this.currentProgramId);
          formData.append('stage', this.stage);

          await this.$axios.post('/api/statistic/', formData);
        }
      } catch (e) {
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "HealthCheck";
</style>
